/*
 * Copyright © 2015-2019 Serenova, LLC. All rights reserved.
 */

import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm } from 'redux-form/immutable';
import DispatchMappingsForm from './layout';
import { formValidation } from './validation';
import { selectNonReusableFlows, selectVersionsFromFlow } from '../../../redux/modules/entities/flows/selectors';
import { selectIntegrations } from '../../../redux/modules/entities/integrations/selectors';
import {
  selectDispatchMappingsFormInitialValues,
  getMappingValueMessage,
  getMappingValueInvalid,
  getDispatchMappings,
  getDuplicatedDispatchMappings
} from '../../../redux/modules/entities/dispatchMappings/selectors';
import { setMappingValueInvalid } from '../../../redux/modules/entities/dispatchMappings/actions';
import {
  getSelectedEntityId,
  isInherited,
  isCreating,
  userHasUpdatePermission,
  isEntityFetching
} from '../../../redux/modules/entities/selectors';
import { formSubmission, createFormName, getCurrentFormValueByFieldName } from '../../../redux/modules/form/selectors';

const CreateDispatchMappingsForm = compose(
  connect(state => createFormName(state)),
  reduxForm({
    onSubmit: formSubmission,
    validate: formValidation,
    destroyOnUnmount: true
  })
)(DispatchMappingsForm);

export function mapStateToProps(state) {
  return {
    channelType: getCurrentFormValueByFieldName(state, 'channelType'),
    dispatchMappingsList: getDispatchMappings(state),
    duplicatedDispatchMappingsList: getDuplicatedDispatchMappings(state),
    flowsFetching: isEntityFetching(state, 'flows'),
    flowId: getCurrentFormValueByFieldName(state, 'flowId'),
    flowIds: selectNonReusableFlows(state),
    flowVersions: selectVersionsFromFlow(state),
    inherited: isInherited(state),
    initialValues: selectDispatchMappingsFormInitialValues(state),
    integrationElements: selectIntegrations(state),
    isMappingValueInvalid: getMappingValueInvalid(state),
    isSaving: isCreating(state),
    key: getSelectedEntityId(state),
    mappingValue: getCurrentFormValueByFieldName(state, 'interactionField'),
    mappingValueMessage: getMappingValueMessage(state),
    userHasUpdatePermission: userHasUpdatePermission(state),
    value: getCurrentFormValueByFieldName(state, 'value')
  };
}

export const actions = {
  setMappingValueInvalid
};

export default connect(mapStateToProps, actions)(CreateDispatchMappingsForm);
